// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__I865D","amount":"Amount_amount__2kNWI","tip":"Amount_tip__3kI3g","tipHeader":"Amount_tipHeader__2z1xl","tipsWrap":"Amount_tipsWrap__1qL56"};